// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"4d85610a","899":"89d8e8e8"}[chunkId] + ".js";
};